/* eslint-disable @next/next/no-img-element */
import React, {useEffect, useRef, useState} from 'react';
import {Button, Tooltip} from 'antd';
import {EditorState} from 'draft-js';
import {useStore} from '@/store/root-store';
import {observer} from 'mobx-react';
import styled from 'styled-components';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faRectangleCode} from '@fortawesome/pro-regular-svg-icons';
import {AtomicBlockUtils} from 'draft-js';
import {Textarea} from '@/components/common-components/components/form/input/input';
import {LargeBadge} from '@/components/common-components/components/badge';

interface Props {
  updateText: (state: EditorState) => void;
  editorState: any;
}

export const InsertIframe = observer(({updateText, editorState}: Props) => {
  const {
    contentOptimizer: {
      currentPage: {currentEditorState},
    },
  } = useStore('');
  const [showIframeEditor, setShowIframeEditor] = useState(false);
  const [url, setUrl] = useState('');
  const dateRef = useRef(null);


  useEffect(() => {
    function handleClickOutside(event) {
      if (
        dateRef.current &&
        !dateRef.current.parentElement.contains(event.target)
      ) {
        setShowIframeEditor(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [dateRef]);


  const iconClicked = (e?: any) => {
    e.preventDefault();
    setShowIframeEditor(true);
  };

  const ele = document.getElementById('numberHeight');
  ele?.addEventListener('keydown', function(e) {
    const keyCode = e.which || e.keyCode;
    if (keyCode === 69 || keyCode === 187 || keyCode === 189) {
      e.preventDefault();
    }
  });

  const insertText = contentData => {
    const currentContent = currentEditorState.getCurrentContent();
    if (contentData) {
      const contentStateWithEntity = currentContent.createEntity(
        'iframe',
        'IMMUTABLE',
        {
          content: contentData,
        },
      );
      const entityKey = contentStateWithEntity.getLastCreatedEntityKey();
      const newEditorState = EditorState.set(editorState, {
        currentContent: contentStateWithEntity,
      });
      return AtomicBlockUtils.insertAtomicBlock(newEditorState, entityKey, ' ');
    }

    return editorState;
  };

  const sendTextToEditor = async () => {
    const urlPattern = /^((http|https):\/\/)/;
    const iframeUrl = urlPattern.test(url) ? url : `http://${url}`;
    const iframeRegex = /<iframe[^>]+src="([^"]+)"[^>]*>/;
    const match = iframeUrl.match(iframeRegex);

    let contentData: any = {
      src: iframeUrl,
      title: 'content',
      height: '315px',
      width: '100%',
      frameBorder: '0',
      allow: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share',
      referrerPolicy: 'strict-origin-when-cross-origin',
      allowFullScreen: true,
    };

    if (match && match[1]) {
      if (match && match[1]) {
        contentData = match[0];
      }
    }

    if (contentData) {
      const contentState = insertText(contentData);
      updateText(contentState);
      setShowIframeEditor(false);
    }
  };

  return (
    <div style={{position: 'relative'}}>
      <Tooltip title='Insert iFrame'>
        <FileBtn
          type='text'
          ref={dateRef}
          onMouseDown={(e: any) => iconClicked(e)}
        >
          <FontAwesomeIcon icon={faRectangleCode} /><LargeBadge alpha />
        </FileBtn>
      </Tooltip>
      {showIframeEditor && (
        <StyledPopup>
          <div className={'inputContainer'}>
            <p className={'textLabel'}>iFrame URL</p>
            <StyledUrlContainer onChange={e => setUrl(e.target.value)}></StyledUrlContainer>
            <div style={{display: 'flex', gap: '10px', marginTop: 17, marginBottom: 19}}>
              <InsertButton disabled={!url || url=='' || url?.trim()==''} onClick={() => sendTextToEditor()}>Insert iFrame</InsertButton>
              <CancelButton onClick={() => setShowIframeEditor(false)}>Cancel</CancelButton>
            </div>
          </div>
        </StyledPopup>
      )}
    </div>
  );
});

const FileBtn = styled(Button)`
display: flex;
align-items: center;
  padding: 4px 6px 6px 6px;
  svg {
    height: 17px;
    color: gray;
  }
`;

const StyledPopup = styled.div`
  width: 490px !important;
  height: 235px;
  background: #fff;
  border: 1px solid #D2D2D2;
  border-radius: 5px;
  box-shadow: 0 6px 25px rgba(0, 0, 0, 0.15);
  display: flex;
  padding: 10px 10px 20px;
  position: absolute;
  width: 330px;
  z-index: 2;
  p {
    color: rgb(78, 81, 86);
  }

  .inputContainer {
    margin-left: 10px;
    margin-right: 10px;
    text-align: initial;
    width: 100%;

    svg {
      height: 12px;
    }

    .textLabel {
      color: #121212 !important;
      font-size: 12px;
      font-weight: 400;
      margin-bottom: 5px !important;
      margin-left: 0 !important;
      margin-right: 0 !important;
      margin-top: 10px !important;
      text-align: left;
    }

    p {
      margin-bottom: 0;
      margin-left: 0;
      margin-right: 0;
      margin-top: 10px;
    }
  }
`;

const StyledUrlContainer = styled(Textarea)`
  width: 460px;
  height: 130px;
  border-radius: 8px;
  border: 1px solid #D2D2D2;
  padding: 10px 13px;
  text-align: left;
  line-height: 1.5;
  display: flex;
  align-items: flex-start;
  white-space: pre-wrap;
  overflow-wrap: break-word;
  background-color: #FFFFFF;
  color: #121212;
`;
const InsertButton = styled(Button)`
  background-color: #2D6CCA;
  padding: 5px 15px;
  border-radius: 6px;
  color: #FFFFFF;

  &:hover {
    background-color: #1E5BB8;
    color: #FFFFFF;
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(45, 108, 202, 0.5);
  }

  &:disabled {
    background-color: #A6C1E6;
    color: #FFFFFF;
    cursor: not-allowed;
  }
`;

const CancelButton = styled(Button)`
  background-color: #F2F2F5;
  color: #4E5156;
  padding: 5px 15px;
  border-radius: 6px;

  &:hover {
    background-color: #E0E0E5;
    color: #4E5156;
    border: 1px solid transparent;
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(242, 242, 245, 0.5);
    border: 1px solid transparent;
  }
`;
